import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
interface InitialFormProps {
  onSubmit: (formData: {
    name: string;
    email: string;
    industry: string;
  }) => Promise<void>;
  isSubmitting: boolean;
}
export const InitialForm = ({
  onSubmit,
  isSubmitting
}: InitialFormProps) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    industry: ""
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(formData);
  };
  const handleChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  return <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="name" className="text-left block text-gray-700">Name</Label>
          <Input id="name" placeholder="Enter your name" value={formData.name} onChange={e => handleChange("name", e.target.value)} className="transition-all duration-200 focus:ring-2 focus:ring-purple-500 border-purple-100" />
        </div>

        <div className="space-y-2">
          <Label htmlFor="email" className="text-left block text-gray-700">Email</Label>
          <Input id="email" type="email" placeholder="Enter your email" value={formData.email} onChange={e => handleChange("email", e.target.value)} className="transition-all duration-200 focus:ring-2 focus:ring-purple-500 border-purple-100" />
        </div>

        <div className="space-y-2">
          <Label htmlFor="industry" className="text-left block text-gray-700">Industry</Label>
          <Input id="industry" placeholder="Your industry" value={formData.industry} onChange={e => handleChange("industry", e.target.value)} className="transition-all duration-200 focus:ring-2 focus:ring-purple-500 border-purple-100" />
        </div>
      </div>

      <div className="space-y-4">
        <Button type="submit" disabled={isSubmitting} className="w-full group bg-gradient-to-r from-purple-600 to-pink-500 hover:from-purple-700 hover:to-pink-600 text-white shadow-lg hover:shadow-xl transition-all duration-200">
          {isSubmitting ? "Saving..." : "Get Started"}
          <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </Button>

        <div className="text-sm text-gray-500 space-y-2">
          <p className="flex items-center justify-center gap-1 text-xs">
            🔒 Your data is secure and we never share your information
          </p>
          <p className="font-normal text-xs">
            By signing up, you agree to our{" "}
            <Link to="/terms" className="text-purple-600 hover:underline">Terms of Service</Link>
            {" "}and{" "}
            <Link to="/privacy" className="text-purple-600 hover:underline">Privacy Policy</Link>
          </p>
        </div>
      </div>
    </form>;
};